import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { environment } from "../environment/environments";

const apiRoute = "/api/";

let token = "";
let orgId = "";
let userId = "";
let programId = "";

const setTokenValues = () => {
  token = `user ${localStorage.getItem("token")}`;
  orgId = localStorage.getItem("orgId");
  userId = localStorage.getItem("userId");
  programId = localStorage.getItem("pid");
}

export const getParticularUser = createAsyncThunk(
    "admin/getParticularUser",
    async ({user, userId}, thunkAPI) => {
      try {
        setTokenValues();
        const response = await fetch(
            environment.baseURL + 
            apiRoute +
            "getParticularUser/" + 
            user + 
            "/" + 
            userId,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: token
            },
          }
        );
        let data = await response.json();
        if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
        
        if (response.status === 200) {
          return data.Data;
        } else {
          return thunkAPI.rejectWithValue(data);
        }
      } catch (e) {
        thunkAPI.rejectWithValue(e.response.data);
      }
    }
  );

export const getMentorAvailableDates = createAsyncThunk(
    "admin/getMentorAvailableDates",
    async (date ,thunkAPI) => {
      try {
        setTokenValues();
        const ate = date ?? "";
        const response = await fetch(
            environment.baseURL + 
            apiRoute +
            userId +
            `/getMentorAvailableDates?date=${ate}` ,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: token
            },
          }
        );
        let data = await response.json();
        if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
        
        if (response.status === 200) {
          return data.Data;
        } else {
          return thunkAPI.rejectWithValue(data);
        }
      } catch (e) {
        thunkAPI.rejectWithValue(e.response.data);
      }
    }
  );

export const getMentorSlotsByDate = createAsyncThunk(
    "admin/getMentorSlotsByDate",
    async (date, thunkAPI) => {
      try {
        setTokenValues();
        const response = await fetch(
            environment.baseURL + 
            apiRoute +
            userId +
            "/getMentorSlotsByDate/" +
            date ,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: token
            },
          }
        );
        let data = await response.json();
        if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
        
        if (response.status === 200) {
          return data.Data;
        } else {
          return thunkAPI.rejectWithValue(data);
        }
      } catch (e) {
        thunkAPI.rejectWithValue(e.response.data);
      }
    }
  );

  export const getUpcomingInterviewDetails = createAsyncThunk("mentor/getUpcomingInterviewDetails", async ({search, date, status, index},thunkAPI) => {
    try {
        setTokenValues();
        const title = search ?? "";
        const ate = date ?? "";
        const ss = status ?? "";
        const page = index ?? "";

        const response = await fetch(environment.baseURL +
            apiRoute +
            userId + `/getUpcomingInterviewDetails/mentor?title=${title}&ate=${ate}&ss=${ss}&page=${page}`,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: token,
                },
            }
        );
        if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
        let data = await response.json();
        if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
        if (response.status === 200) {
            return data.Data;
        } else {
            return thunkAPI.rejectWithValue(data);
        }
    } catch (error) {
        return thunkAPI.rejectWithValue({ error: error.message });
    }
}
);

export const getPastInterviewDetails = createAsyncThunk("mentor/getPastInterviewDetails", async ({search, date, status, index}, thunkAPI) => {
    try {
        setTokenValues();
        const title = search ?? "";
        const ate = date ?? "";
        const ss = status ?? "";
        const page = index ?? "";

        const response = await fetch(environment.baseURL +
            apiRoute +
            userId + `/getPastInterviewDetails/mentor?title=${title}&ate=${ate}&ss=${ss}&page=${page}`,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: token,
                },
            }
        );
        let data = await response.json();
        if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
        if (response.status === 200) {
            return data.Data;
        } else {
            return thunkAPI.rejectWithValue(data);
        }
    } catch (error) {
        return thunkAPI.rejectWithValue({ error: error.message });
    }
}
);

export const getUserFeedback = createAsyncThunk("mentor/getUserFeedback", async (feedbackId, thunkAPI) => {
    try {
        setTokenValues();

        const response = await fetch(environment.baseURL +
            apiRoute +
            userId +
            "/booking/" +
            feedbackId + 
            "/getUserFeedback/mentor",
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: token,
                },
            }
        );
        let data = await response.json();
        if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
        if (response.status === 200) {
            return data.Data;
        } else {
            return thunkAPI.rejectWithValue(data);
        }
    } catch (error) {
        return thunkAPI.rejectWithValue({ error: error.message });
    }
}
);

  export const addMentorAvailableSlots = createAsyncThunk("mentor/addMentorAvailableSlots", async (obj, thunkAPI) => {
    try {
        setTokenValues();
        const response = await fetch(environment.baseURL +
            apiRoute +
            programId +
            "/" +
            userId +
            "/addMentorAvailableSlots",
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: token,
                },
                body: JSON.stringify(obj)
            }
        );
        let data = await response.json();
        if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
        if (response.status === 200) {
            return data;
        } else {
            return thunkAPI.rejectWithValue(data);
        }
    } catch (error) {
        return thunkAPI.rejectWithValue({ error: error.message });
    }
}
);

  export const saveUserFeedbackAnswers = createAsyncThunk("mentor/saveUserFeedbackAnswers", async ({feedbackId, obj}, thunkAPI) => {
    try {
        setTokenValues();
        const response = await fetch(environment.baseURL +
            apiRoute +
            "booking/" +
            feedbackId +
            "/saveUserFeedbackAnswers/mentor",
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: token,
                },
                body: JSON.stringify(obj)
            }
        );
        let data = await response.json();
        if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
        if (response.status === 200) {
            return data;
        } else {
            return thunkAPI.rejectWithValue(data);
        }
    } catch (error) {
        return thunkAPI.rejectWithValue({ error: error.message });
    }
}
);

export const resheduleInterview = createAsyncThunk("mentee/resheduleInterview", async ({slotId, obj}, thunkAPI) => {
  try {
      setTokenValues();
      const response = await fetch(environment.baseURL +
          apiRoute +
          slotId +
          "/resheduleInterview",
          {
              method: "POST",
              headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: token,
              },
              body: JSON.stringify(obj)
          }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      if (response.status === 200) {
          return data;
      } else {
          return thunkAPI.rejectWithValue(data);
      }
  } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
  }
}
);

  export const cancelInterview = createAsyncThunk("mentor/cancelInterview", async ({slotId, reason}, thunkAPI) => {
    try {
        setTokenValues();
        const response = await fetch(environment.baseURL +
            apiRoute +
            slotId +
            "/cancelInterview",
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: token,
                },
                body: JSON.stringify({reason})
            }
        );
        let data = await response.json();
        if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
        if (response.status === 200) {
            return data;
        } else {
            return thunkAPI.rejectWithValue(data);
        }
    } catch (error) {
        return thunkAPI.rejectWithValue({ error: error.message });
    }
}
);

  export const updateUserDetails = createAsyncThunk("mentor/updateUserDetails", async (obj, thunkAPI) => {
    try {
        setTokenValues();
        const response = await fetch(environment.baseURL +
            apiRoute +
            "updateUserDetails",
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: token,
                },
                body: JSON.stringify(obj)
            }
        );
        let data = await response.json();
        if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
        if (response.status === 200) {
            return data;
        } else {
            return thunkAPI.rejectWithValue(data);
        }
    } catch (error) {
        return thunkAPI.rejectWithValue({ error: error.message });
    }
}
);

export const changePassword = createAsyncThunk(
    "mentor/changePassword",
    async (obj, thunkAPI) => {
      try {
        const response = await fetch(
            environment.baseURL + 
            apiRoute +
            "changePassword",
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: token,
            },
            body: JSON.stringify(obj),
          }
        );
        let data = await response.json();
        if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
        
        if (response.status === 200) {
          return data.Data;
        } else {
          return thunkAPI.rejectWithValue(data);
        }
      } catch (e) {
        thunkAPI.rejectWithValue(e.response.data);
      }
    }
  );

  export const getInterestsAndTopics = createAsyncThunk(
    "admin/getInterestsAndTopics",
    async ( thunkAPI ) => {
      try {
        setTokenValues();
        const response = await fetch(
            environment.baseURL + 
            apiRoute +
            programId +
            "/getInterestsAndTopics",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: token,
            }
          }
        );
        let data = await response.json();
        if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
        
        if (response.status === 200) {
          return data?.Data;
        } else {
          return thunkAPI.rejectWithValue(data);
        }
      } catch (e) {
        thunkAPI.rejectWithValue(e.response.data);
      }
    }
  );

  export const getMentorCallsActivity = createAsyncThunk(
    "admin/getMentorCallsActivity",
    async ( thunkAPI ) => {
      try {
        setTokenValues();
        const response = await fetch(
            environment.baseURL + 
            apiRoute +
            programId +
            "/getMentorCallsActivity/" +
            userId,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: token
            },
          }
        );
        let data = await response.json();
        if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
        
        if (response.status === 200) {
          return data.Data;
        } else {
          return thunkAPI.rejectWithValue(data);
        }
      } catch (e) {
        thunkAPI.rejectWithValue(e.response.data);
      }
    }
  );

  export const getMentorPerformance = createAsyncThunk(
    "admin/getMentorPerformance",
    async ( thunkAPI ) => {
      try {
        setTokenValues();
        const response = await fetch(
            environment.baseURL + 
            apiRoute +
            programId +
            "/getMentorPerformance/" +
            userId,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: token
            },
          }
        );
        let data = await response.json();
        if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
        
        if (response.status === 200) {
          return data.Data;
        } else {
          return thunkAPI.rejectWithValue(data);
        }
      } catch (e) {
        thunkAPI.rejectWithValue(e.response.data);
      }
    }
  );

  export const deleteMentorInterviewSlot = createAsyncThunk("admin/deleteMentorInterviewSlot", async (slotId, thunkAPI) => {
    try {
        setTokenValues();
        const response = await fetch(environment.baseURL +
            apiRoute +
            "/" +
            slotId +
            "/deleteMentorInterviewSlot",
            {
                method: "DELETE",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: token,
                }
            }
        );
        let data = await response.json();
        if (response.statusText === 'Unauthorized') {
              localStorage.clear();
              window.location.reload();
          }
        if (response.status === 200) {
            return data;
        } else {
            return thunkAPI.rejectWithValue(data);
        }
    } catch (error) {
        return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
  );

  export const mentorSlice = createSlice({
    name: "mentor",
    initialState: {
      isFetching: false,
      isDashboardFetching: false,
      isSlotsFetching: false,
      isPerformanceFetching: false,
      isSlotDatesFetching: false,
      isLoaderFetching: false,
      isSuccess: false,
      isUserAddedSuccess: false,
      isError: false,
      errorMessage: "",
      particularUser: [],
      mentorSlotDates: [],
      mentorSlots: [],
      upcomingCalls: [],
      pastCalls: [],
      feedback: {},
      interestTopics: [],
      dashboardData: [],
      token: localStorage.getItem('token') ? localStorage.getItem('token') : null,
    },
    reducers: {
      clearState: (state) => {
        state.isError = false;
        state.errorMessage = "";
        state.isSuccess = false;
        state.isFetching = false;
        state.isDashboardFetching = false;
        state.isSlotsFetching = false;
        state.isPerformanceFetching = false;
        state.isSlotDatesFetching = false;
        state.isLoaderFetching = false;
        state.isUserAddedSuccess = false;
        return state;
      },
      clearSlots: (state) => {
        state.mentorSlots = [];
        return state;
      },
      clearSlotDates: (state) => {
        state.mentorSlotDates = [];
        return state;
      },
    },
    extraReducers: (builder) => {
      builder.addCase(getParticularUser.pending, (state) => {
          state.isFetching = true;
      });
      builder.addCase(getParticularUser.fulfilled, (state, { payload }) => {
          state.isFetching = false;
          state.particularUser = payload;
      });
      builder.addCase(getParticularUser.rejected, (state, {payload}) => {
          state.isFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(getMentorAvailableDates.pending, (state) => {
          state.isSlotDatesFetching = true;
      });
      builder.addCase(getMentorAvailableDates.fulfilled, (state, { payload }) => {
          state.isSlotDatesFetching = false;
          state.mentorSlotDates = payload;
      });
      builder.addCase(getMentorAvailableDates.rejected, (state, {payload}) => {
          state.isSlotDatesFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(getMentorSlotsByDate.pending, (state) => {
          state.isSlotsFetching = true;
      });
      builder.addCase(getMentorSlotsByDate.fulfilled, (state, { payload }) => {
          state.isSlotsFetching = false;
          state.mentorSlots = payload;
      });
      builder.addCase(getMentorSlotsByDate.rejected, (state, {payload}) => {
          state.isSlotsFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(getUpcomingInterviewDetails.pending, (state) => {
          state.isFetching = true;
      });
      builder.addCase(getUpcomingInterviewDetails.fulfilled, (state, { payload }) => {
          state.isFetching = false;
          state.upcomingCalls = payload;
      });
      builder.addCase(getUpcomingInterviewDetails.rejected, (state, {payload}) => {
          state.isFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(getPastInterviewDetails.pending, (state) => {
          state.isFetching = true;
      });
      builder.addCase(getPastInterviewDetails.fulfilled, (state, { payload }) => {
          state.isFetching = false;
          state.pastCalls = payload;
      });
      builder.addCase(getPastInterviewDetails.rejected, (state, {payload}) => {
          state.isFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(getUserFeedback.pending, (state) => {
          state.isLoaderFetching = true;
      });
      builder.addCase(getUserFeedback.fulfilled, (state, { payload }) => {
          state.isLoaderFetching = false;
          state.feedback = payload;
      });
      builder.addCase(getUserFeedback.rejected, (state, {payload}) => {
          state.isLoaderFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(getMentorCallsActivity.pending, (state) => {
          state.isDashboardFetching = true;
      });
      builder.addCase(getMentorCallsActivity.fulfilled, (state, { payload }) => {
          state.isDashboardFetching = false;
          state.dashboardCalls = payload;
      });
      builder.addCase(getMentorCallsActivity.rejected, (state, {payload}) => {
          state.isDashboardFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(getMentorPerformance.pending, (state) => {
          state.isPerformanceFetching = true;
      });
      builder.addCase(getMentorPerformance.fulfilled, (state, { payload }) => {
          state.isPerformanceFetching = false;
          state.dashboardPerformance = payload;
      });
      builder.addCase(getMentorPerformance.rejected, (state, {payload}) => {
          state.isPerformanceFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(getInterestsAndTopics.pending, (state) => {
          // state.isFetching = true;
      });
      builder.addCase(getInterestsAndTopics.fulfilled, (state, { payload }) => {
          // state.isFetching = false;
          state.interestTopics = payload;
      });
      builder.addCase(getInterestsAndTopics.rejected, (state, {payload}) => {
          // state.isFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(addMentorAvailableSlots.pending, (state) => {
          state.isLoaderFetching = true;
      });
      builder.addCase(addMentorAvailableSlots.fulfilled, (state) => {
          state.isLoaderFetching = false;
          state.isSuccess = true;
      });
      builder.addCase(addMentorAvailableSlots.rejected, (state, {payload}) => {
          state.isLoaderFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(resheduleInterview.pending, (state) => {
        state.isFetching = true;
      });
      builder.addCase(resheduleInterview.fulfilled, (state) => {
          state.isFetching = false;
          state.isSuccess = true;
      });
      builder.addCase(resheduleInterview.rejected, (state, {payload}) => {
          state.isFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(cancelInterview.pending, (state) => {
          state.isLoaderFetching = true;
      });
      builder.addCase(cancelInterview.fulfilled, (state) => {
          state.isLoaderFetching = false;
          state.isSuccess = true;
      });
      builder.addCase(cancelInterview.rejected, (state, {payload}) => {
          state.isLoaderFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(saveUserFeedbackAnswers.pending, (state) => {
          state.isFetching = true;
      });
      builder.addCase(saveUserFeedbackAnswers.fulfilled, (state) => {
          state.isFetching = false;
          state.isSuccess = true;
      });
      builder.addCase(saveUserFeedbackAnswers.rejected, (state, {payload}) => {
          state.isFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(updateUserDetails.pending, (state) => {
          state.isFetching = true;
      });
      builder.addCase(updateUserDetails.fulfilled, (state) => {
          state.isFetching = false;
          state.isSuccess = true;
      });
      builder.addCase(updateUserDetails.rejected, (state, {payload}) => {
          state.isFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(changePassword.pending, (state) => {
          state.isFetching = true;
      });
      builder.addCase(changePassword.fulfilled, (state, { payload }) => {
          state.isFetching = false;
          state.isSuccess = true;
      });
      builder.addCase(changePassword.rejected, (state, {payload}) => {
          state.isFetching = false;
          state.isError = true;
          state.errorMessage = payload.Message ?? "Something went wrong!";
      });
      builder.addCase(deleteMentorInterviewSlot.pending, (state) => {
        state.isFetching = true;
      });
      builder.addCase(deleteMentorInterviewSlot.fulfilled, (state) => {
          state.isFetching = false;
          state.isSuccess = true;
      });
      builder.addCase(deleteMentorInterviewSlot.rejected, (state, {payload}) => {
          state.isFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
    },
  });
  
  
  export const { clearState } = mentorSlice.actions;
  export const { clearSlots } = mentorSlice.actions;
  export const { clearSlotDates } = mentorSlice.actions;
  
  export const mentorData = (state) => state.mentor;